import type { JSX } from 'react'
import { useTranslation } from 'react-i18next'

import { useArabicSessionLanguage } from '@context/SessionSettingsContext'

import { IconButton } from '@ui/components/Button'
import { Tooltip } from '@ui/components/Tooltip/Tooltip'
import { CaretIcon } from '@ui/icons/Caret.icon'

import { SCROLL_SPEED } from '@hooks/useHorizontalControlScroll'

import styles from '../../Loyalty/LoyaltyPage.module.scss'

interface Props {
  onScroll: (direction: 'left' | 'right', speed?: number) => void
  onHandleKeyDownScroll: (e: React.KeyboardEvent<HTMLButtonElement>) => void
  stopScrolling: () => void
}

export const LoyaltySliderControls = ({
  onScroll,
  stopScrolling,
  onHandleKeyDownScroll,
}: Props): JSX.Element => {
  const isArabic = useArabicSessionLanguage()
  const { t } = useTranslation()

  return (
    <nav className={styles.sliderControls} aria-label='Loyalty tier slider controls'>
      <Tooltip
        content={!isArabic ? t('Move Left') : t('Move Right')}
        wrapperClassName={styles.sliderControlTooltip}
      >
        <IconButton.Ghost
          icon={CaretIcon.Left}
          onMouseDown={() => onScroll(!isArabic ? 'left' : 'right', SCROLL_SPEED.FAST)}
          onMouseUp={stopScrolling}
          onMouseLeave={stopScrolling}
          onKeyDown={onHandleKeyDownScroll}
          onKeyUp={stopScrolling}
          aria-label={!isArabic ? 'Scroll left' : 'Scroll right'}
        />
      </Tooltip>
      <Tooltip
        content={!isArabic ? t('Move Right') : t('Move Left')}
        wrapperClassName={styles.sliderControlTooltip}
      >
        <IconButton.Ghost
          icon={CaretIcon.Right}
          onMouseDown={() => onScroll(!isArabic ? 'right' : 'left', SCROLL_SPEED.FAST)}
          onMouseUp={stopScrolling}
          onMouseLeave={stopScrolling}
          onKeyDown={onHandleKeyDownScroll}
          onKeyUp={stopScrolling}
          aria-label={!isArabic ? 'Scroll right' : 'Scroll left'}
        />
      </Tooltip>
    </nav>
  )
}
